import SpecificHand from '@/services/hands/SpecificHand';
import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  inRange: function (generalHands) {
    let pairGeneralHandsInRange = this._getPairGeneralHandsInRange(generalHands);
    let groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsInRange);
    let textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  manuallyAdded: function (generalHands) {
    let pairGeneralHandsManuallyAdded = this._getPairGeneralHandsManuallyAdded(generalHands);
    let groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsManuallyAdded);
    let textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  manuallyRemoved: function (generalHands) {
    let pairGeneralHandsManuallyRemoved = this._getPairGeneralHandsManuallyRemoved(generalHands);
    let groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsManuallyRemoved);
    let textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  _getPairGeneralHandsInRange: function (generalHands) {
    let listOfPairGeneralHandsInRange = [];

    constants.textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      let pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.inRange === true) {
        listOfPairGeneralHandsInRange.push(pairGeneralHand);
      } else if (pairGeneralHand.inRange === 'partial') {
        pairGeneralHand.forEachSpecificHandInRange(function (specificHand) {
          listOfPairGeneralHandsInRange.push(specificHand);
        });
      }
    });

    return listOfPairGeneralHandsInRange;
  },
  _getPairGeneralHandsManuallyAdded: function (generalHands) {
    let listOfPairGeneralHandsManuallyAdded = [];

    constants.textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      let pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.manuallyAdded === true) {
        listOfPairGeneralHandsManuallyAdded.push(pairGeneralHand);
      } else if (pairGeneralHand.manuallyAdded === 'partial') {
        pairGeneralHand.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfPairGeneralHandsManuallyAdded.push(specificHand);
          }
        });
      }
    });

    return listOfPairGeneralHandsManuallyAdded;
  },
  _getPairGeneralHandsManuallyRemoved: function (generalHands) {
    let listOfPairGeneralHandsManuallyRemoved = [];

    constants.textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      let pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.manuallyRemoved === true) {
        listOfPairGeneralHandsManuallyRemoved.push(pairGeneralHand);
      } else if (pairGeneralHand.manuallyRemoved === 'partial') {
        pairGeneralHand.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfPairGeneralHandsManuallyRemoved.push(specificHand);
          }
        });
      }
    });

    return listOfPairGeneralHandsManuallyRemoved;
  },
  _getGroupsOfConsecutivePairs: function (pairGeneralHandsInRange) {
    let groupsOfConsecutivePairs = [];
    let currGroupOfConsecutivePairs = [];

    pairGeneralHandsInRange.forEach(function (pairGeneralHandInRange) {
      let pairGeneralHandInRangeIsNextInOrder = this._isPairGeneralHandInRangeNextInOrder(pairGeneralHandInRange, _.last(currGroupOfConsecutivePairs));

      if (
        (currGroupOfConsecutivePairs.length === 0) ||
        (pairGeneralHandInRangeIsNextInOrder)
      ) {
        currGroupOfConsecutivePairs.push(pairGeneralHandInRange);
      } else {
        groupsOfConsecutivePairs.push(currGroupOfConsecutivePairs);
        currGroupOfConsecutivePairs = [];
        currGroupOfConsecutivePairs.push(pairGeneralHandInRange)
      }
    }, this);

    if (currGroupOfConsecutivePairs.length > 0) {
      groupsOfConsecutivePairs.push(currGroupOfConsecutivePairs);
    }

    return groupsOfConsecutivePairs;
  },
  _isPairGeneralHandInRangeNextInOrder: function (currPair, previousPair) {
    if (currPair instanceof SpecificHand) {
      return false;
    }

    if (!previousPair) {
      return true;
    }

    let currPairRank = currPair.rankOne;
    let previousPairRank = previousPair.rankOne;

    return utilities.ranks.getRankOneLower(previousPairRank) === currPairRank;
  },
  _getTextFromGroupsOfConsecutivePairs: function (groupsOfConsecutivePairs) {
    let textFromGroupsOfConsecutivePairs = '';

    groupsOfConsecutivePairs.forEach(function (groupOfConsecutivePairs) {
      textFromGroupsOfConsecutivePairs += this._getTextFromGroupOfConsecutivePairs(groupOfConsecutivePairs) + ', ';
    }, this);

    return textFromGroupsOfConsecutivePairs;
  },
  _getTextFromGroupOfConsecutivePairs: function (groupOfConsecutivePairs) {
    let firstPairString = groupOfConsecutivePairs[0].string;
    let lastPairString = _.last(groupOfConsecutivePairs).string;

    if (groupOfConsecutivePairs.length === 1) {
      return firstPairString;
    } else if (lastPairString === '22') {
      return firstPairString + '-';
    } else if (firstPairString === 'aa') {
      return lastPairString + '+';
    } else {
      return firstPairString + '-' + lastPairString;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/text/get-text-from-general-hands/get-text-from-pairs.js